import { Tag } from "@/components/elements/Tag";
import { black, lightBlue, orange, pink, teal } from "@/theme/colors";
import { CASE_STATUS } from "@/features/case/constants/caseStatus";
import { FCC } from "@/types/common";

type CaseStatusType = (typeof CASE_STATUS)[keyof typeof CASE_STATUS];
type CaseStatusStyle = {
  background: string;
  title: string;
};
type Props = {
  status: CaseStatusType;
};

export const CaseTagStatus: FCC<Props> = ({ status }) => {
  const statusOption: Record<CaseStatusType, CaseStatusStyle> = {
    [CASE_STATUS.JOB_POSTED]: { background: black[99], title: "求人情報登録" },
    [CASE_STATUS.PREPARING_PROPOSAL]: { background: black[99], title: "人材提案準備中" },
    [CASE_STATUS.PROPOSING_CANDIDATE]: { background: lightBlue[92], title: "人材提案中" },
    [CASE_STATUS.INTERVIEWING]: { background: orange[97], title: "面接選考中" },
    [CASE_STATUS.OFFERED]: { background: teal[100], title: "内定" },
    [CASE_STATUS.WAITING_FOR_JOINING]: { background: teal[100], title: "入社待ち" },
    [CASE_STATUS.RECRUITMENT_STOPPED]: { background: pink[96], title: "募集中止" },
  };

  const current = statusOption[status];

  return <Tag color={current.background} textColor={black[30]} title={current.title} fontWeight={400} size="medium" />;
};
